(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('personCompanyAssociation', PersonCompanyAssociation)

    /** @ngInject */
    function PersonCompanyAssociation($q, LoadingHelper, ResponsibilityService, PermissionGroupService, AuthenticationService, UtilHelper, PATHS_FRANCHISER, DEFAULT_IDENTIFIERS) {
        function PersonCompanyAssociationController() {
            const vm = this;

            vm.initPersonCompanyVars = (index, personCompany) => {
                vm.personCompanyAssociationData[index] = {
                    CompanyId: personCompany.CompanyId,
                    PermissionGroupId: null,
                    ResponsibilityId: null
                }
            }

            vm.searchCompanyInFoundPerson = companyId => {
                if (!vm.foundPerson)
                    return false;

                return vm.foundPerson.PersonCompanies.find(personCompany => (personCompany.CompanyId == companyId));
            }

            vm.getAllData = () => {
                LoadingHelper.startLoading('.company-permission-listing');

                if (vm.loggedUserData.PermissionGroupId == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR ||
                    vm.loggedUserData.PermissionGroupId == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_WORKER) {
                    $q.all([getResponsibilities(), getPermissionGroups()])
                        .then(() => {
                            LoadingHelper.stopLoading('.company-permission-listing');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.company-permission-listing');
                        })
                } else {
                    $q.all([getResponsibilities()])
                        .then(() => {
                            LoadingHelper.stopLoading('.company-permission-listing');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.company-permission-listing');
                        })
                }
            }

            vm.isPermissionGroupRequired = () => {
                let foundAnyCompany = vm.personCompanyAssociationData.find(personCompany => (personCompany.PermissionGroupId != null));

                return foundAnyCompany == undefined;
            }

            vm.isResponsibilityRequired = () => {
                let foundAnyCompany = vm.personCompanyAssociationData.find(personCompany => (personCompany.ResponsibilityId != null));

                return foundAnyCompany == undefined;
            }

            vm.canEditPermissionGroup = () => {
                return vm.loggedUserData.PermissionGroup.Id == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR && !vm.isEditingFranchiseeCompany;
            }

            init();

            function getResponsibilities() {
                return ResponsibilityService
                    .getAll()
                    .then(success => {
                        if (vm.isEditingFranchiseeCompany) {
                            vm.responsibilities = success.Registers.filter(resp => (resp.Id == 4));
                        } else {
                            vm.responsibilities = success.Registers.filter(resp => (resp.Id != 4));
                        }
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.company-permission-listing');
                    })
                    .catch(error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.company-permission-listing');
                    })
            }

            function getPermissionGroups() {
                return PermissionGroupService
                    .getAll()
                    .then(success => {
                        vm.permissionGroups = success.Registers.filter(permissionGroup => (permissionGroup.Id == 1 || permissionGroup.Id == 2 || permissionGroup.Id == 5 || permissionGroup.Id == 6));
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.company-permission-listing');
                    })
                    .catch(error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.company-permission-listing');
                    })
            }

            function init() {
                vm.loggedUserData = AuthenticationService.getUser();
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getAllData();
        }

        return {
            bindToController: true,
            controller: PersonCompanyAssociationController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/person-company-association/person-company-association.html`,
            scope: {
                loggedPersonAvailableCompanies: '=',
                foundPerson: '=',
                personCompanyAssociationData: '=',
                isEditingFranchiseeCompany: '='
            }
        }
    }
}());